module.exports = __webpack_public_path__ + "img/65085ff705048c514120062c740ad69f.svg";